import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
export const API = process.env.REACT_APP_BACKEND_URL + '/api';

const PartnerContext = createContext(null);

export const usePartner = () => useContext(PartnerContext);

export function PartnerProvider({ children }) {
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('partner_token');
    if (!token) { setLoading(false); return; }
    axios.get(`${API}/partner/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setPartner(r.data))
      .catch(() => { localStorage.removeItem('partner_token'); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/partner/auth/login`, { email, password });
    localStorage.setItem('partner_token', data.access_token);
    setPartner(data.partner);
    return data.partner;
  };

  const logout = () => {
    localStorage.removeItem('partner_token');
    setPartner(null);
  };

  const token = localStorage.getItem('partner_token');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <PartnerContext.Provider value={{ partner, setPartner, loading, login, logout, token, headers }}>
      {children}
    </PartnerContext.Provider>
  );
}
